<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/timelinetopnew.png" class="img" />
        <div class="wait" v-if="nonemess">敬请期待！</div>
        <!-- <div class="searchrow">
            <input class="searchinput" type="text" v-model="searchval" placeholder="请输入讲者主持人姓名查询">
            <img class="searchicon" src="../../assets/images/timesearch.png" alt="">
        </div> -->
        <div class="daterow">
            <div class="dateitem" v-for="(item, index) in searchdate" :key="index"
                @click="listdate(item.DateStr, index)" :class="{ 'active': activedate === index }">{{ item.DateZH }}
            </div>
        </div>
        <div class="meetingtip" v-for="(item, index) in datemeetinglist" :key="index"
            @click="toinfo(item.Id, item.Theme)">
            <div class="meetingplace">
                <img class="meetingpicon" src="../../assets/images/meetingplace.png" alt="">
                <div class="bw">会议地点：{{ item.Address }}</div>
            </div>
            <div class="meetingmain">
                <div class="mrow">
                    <img class="meetingpicon" src="../../assets/images/meetingtime.png" alt="">
                    <div class="bp">时间：{{ item.DateTimeStr }}</div>
                </div>
                <div class="mrow1">
                    <img class="meetingpicon" src="../../assets/images/meetingtitle.png" alt="">
                    <div class="bp">主题：{{ item.Theme }}</div>
                </div>
                <div class="mrow2">
                    <img class="meetingpicon" src="../../assets/images/meetingchairman.png" alt="">
                    <div class="bp">主席：{{ item.Chairman }}</div>
                </div>
            </div>
        </div>
        <floatback />
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'timeline',
    data() {
        return {
            searchval: "",
            searchdate: [],
            activedate: 0,
            datemeetinglist: [],
            nonemess: 0,
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initacmedShare();
        document.title = "ACMED第一届学术年会";
        this.getdate()
    },
    methods: {
        getdate() {
            let that = this;
            this.$axios.post(' /api/api/web/activity/GetScheduleDateNew', {
                ActivityCode: "acmedtest",
            }).then(res => {
                that.searchdate = res.Data
                if (res.Data.length > 0) {
                    that.$axios.post(' /api/api/web/activity/GetSchedule', {
                        ActivityCode: "acmedtest",
                        Date: res.Data[0].DateStr
                    }).then(res => {
                        that.datemeetinglist = res.Data
                        // console.log(res.Data)
                    })
                } else {
                    that.nonemess = 1
                }
                // console.log(res.Data)
            })
        },
        listdate(e, i) {
            let that = this;
            // console.log(e)
            this.activedate = i
            // console.log(i)
            this.$axios.post(' /api/api/web/activity/GetSchedule', {
                ActivityCode: "acmedtest",
                Date: e
            }).then(res => {
                that.datemeetinglist = res.Data
                // that.searchdate = res.Data
                // console.log(res.Data)
            })
        },
        toinfo(i, t) {
            this.$router.push({
                path: 'acmedmeetinginfo',
                query: {
                    Id: i,
                    title: t
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
    background: rgb(227, 235, 253);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(179, 178, 255);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: #b3b2ff;
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: 1rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(177, 172, 255);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.name {
    width: 50%;
    // text-align: center;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.name1 {
    width: 50%;
    text-align: right;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.perplebold {
    color: #8483d1;
    font-weight: bold;
}

.wait {
    text-align: center;
    color: rgb(111, 86, 250);
    font-weight: bold;
    font-size: .55rem;
    margin-top: 20%;
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.searchrow {
    width: 90%;
    background: #fff;
    margin: auto;
    margin-top: 0.5rem;
    border-radius: 0.133333rem;
    box-shadow: -0.026667rem 0.053333rem 0.16rem 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.3rem;
    box-sizing: border-box;
}

.searchinput {
    width: 85%;
    border: 0;
}

.searchicon {
    display: block;
    width: 8%;
    padding-left: 4%;
    border-left: 1px solid #c3c3c3;
}

.daterow {
    display: flex;
    width: 90%;
    margin: auto;
    overflow-x: auto;
    color: #003585;
    margin-top: 0.5rem;
    padding-bottom: 0.2rem;
    margin-bottom: 0.3rem;
}

.dateitem {
    background: linear-gradient(to right, #fff, #eaf0fb);
    font-size: .5rem;
    padding: 0.3rem 0.3rem;
    margin-right: 0.5rem;
    flex: 0 0 auto;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}

.active {
    background: linear-gradient(to right, rgb(0, 53, 133), rgb(0, 61, 193));
    color: #fff
}

.meetingtip {
    width: 90%;
    margin: auto;
    margin-bottom: 0.5rem;
}

.meetingplace {
    background: linear-gradient(to right, rgb(0, 53, 133), rgb(0, 61, 193));
    color: #fff;
    display: flex;
    flex-direction: row;
    padding: 0.3rem;
    align-items: center;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    margin-bottom: 0.3rem;
}

.bw {
    color: #fff;
    font-size: .45rem;
    margin-left: 0.2rem;
    font-weight: bold;
}

.meetingpicon {
    width: 6%;
}

.meetingmain {
    background: linear-gradient(to right, #fff, #eaf0fb);
    color: #6E56FB;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 0.3rem;
}

.mrow {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.3rem;
}

.mrow1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0;
    margin-bottom: 0.3rem;
}

.mrow2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0;
}

.bp {
    color: #003585;
    font-size: .45rem;
    font-weight: bold;
    margin-left: 0.2rem;
}

.wait {
    text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .55rem;
    padding-top: 20%;
}
</style>